import styled from '@emotion/styled';
import { RangePicker, pxToRem } from '@modernhealth/vital-components';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { color, font } from 'src/shared/styles/variables';

interface Props {
    questionId: string;
    questionTitle: string;
    response: number;
    handleResponseChange: (questionId: string, value: number) => void;
}

const StyledTitle = styled('div')(
    {
        height: 26,
        lineHeight: '26px',
        color: color.blueBayoux,
        marginBottom: pxToRem(12),
    },
    font.medium(font.size.base),
);

const Container = styled('div')({
    marginBottom: pxToRem(28),
});

export const ReviewInputNumerical: React.FC<Props> = ({
    questionId,
    questionTitle,
    response,
    handleResponseChange,
}) => {
    const { t } = useTranslation();
    const handleChange = value => {
        handleResponseChange(questionId, Number(value));
    };

    return (
        <Container>
            <StyledTitle>{t(questionTitle)}</StyledTitle>

            <RangePicker
                labelledBy={t(questionTitle)}
                range={5}
                minLabel={t('intakeForms:numerical_rating.least_important')}
                maxLabel={t('intakeForms:numerical_rating.most_important')}
                onValueChange={handleChange}
                value={response ?? undefined}
            />
        </Container>
    );
};
